
import common from "../../api/common";
import commNav from "@/components/nav/index.vue";
import Loading from 'vux/src/components/loading/index.vue'

import { Badge } from "we-vue";
export default {
components: {
commNav,
Loading
},
props: {},
data() {
return {
isShow:'',//是否锁定患者
active:0,
patientid: this.$store.state.userInfo.id,
inquiry:[],
isDisable:true,
doctorList: [],
patientId: "",
msgList: {},//最新一条聊天记录,
showLoading: false,
loadText: '数据加载中',
inqueryPeople:'',
websocket: null,
websocketPeople:[],
websocketPeople1:'',
inquerypeople:"",
ws: null,//建立的连接
lockReconnect: false,//是否真正建立连接
timeout: 28*1000,//30秒一次心跳
timeoutObj: null,//心跳心跳倒计时
serverTimeoutObj: null,//心跳倒计时
timeoutnum: null,//断开 重连倒计时
};
},
created() {
var _this = this;
document.title = '我的医生'
this.$isLogin(window.location.search.substr(1), _this.query);


this.$store.state.websocketdosome['onTextMessage'] = function(message){
_this.query();
},
this.$store.state.websocketdosome['onPictureMessage'] = function(message){
_this.query();
},
this.$store.state.websocketdosome['onAudioMessage'] = function(message){
_this.query();
},
setTimeout(function () {
_this.websocketPeople1=JSON.parse(localStorage.getItem("temp"))?JSON.parse(localStorage.getItem("temp")):[];
}
,100)
_this.initWebSocket();



},

methods: {

getMyInquiry(){
let params = {
parameters: this.patientid
};
let _this=this;

this.$doRequest("/api/inquiryPeople/getPatientInquiryPatient", params, res=>{
_this.inquiry=res.parameters;
let arr={name:'全部',id:this.$store.state.userInfo.id,age:'我的消息',relationCode:""}
_this.inquiry.unshift(arr);
})
},
getDoctor(item,index){
var _this=this;
_this.inquerypeople=item;
_this.active=index;
if(item.id){
_this.$loginout(_this); 

var userInfo={
id:item.id,
};
setTimeout(function(){

_this.$login(_this,userInfo);
},100);
};

var newtemp=JSON.parse(localStorage.getItem("temp"));
if(newtemp!=null){
newtemp.forEach(function(item1, index, arr) {
if(item1 == item.id) {
arr.splice(index, 1);
}
});
localStorage.removeItem("temp");
localStorage.setItem("temp",JSON.stringify(newtemp));
_this.websocketPeople1=localStorage.getItem("temp")?localStorage.getItem("temp"):[];
}

_this.query(item);
},
query() {
this.showLoading = true;
var ids=this.inquerypeople;
if(ids){
var id=ids.id;
var ids1=ids;
}else{
var id = this.$store.state.userInfo.id;
var ids1={name:'全部',id:this.$store.state.userInfo.id,age:'我的消息',relationCode:""}
}

this.patientid = this.$store.state.userInfo.id;
var _this = this;
this.$doRequest("/api/Inquiry/GetDoctors", { parameters: id ,parametersone:id==this.$store.state.userInfo.id&&ids1.relationCode!="br"?1:0}, res => {
_this.showLoading = false;
_this.isDisable=false;
_this.isShow=res.isShow;
_this.doctorList = [];
var msg = localStorage.getItem('msgsuccess') ? JSON.parse(localStorage.getItem('msgsuccess')) : {};
var oldList = [];
var newList = [];
for (var i = 0; i < res.doctorsItems.length; i++) {
var doctorId = res.doctorsItems[i].doctorId;

if(msg[doctorId]){

var msgList= msg[doctorId].filter(item => item.fromid == res.doctorsItems[i].inquiryPatientId || item.to==res.doctorsItems[i].inquiryPatientId);
}else{
var msgList = msg[doctorId];
}

if(msgList != null && msgList.length>0){
var lastMsg = msgList[msgList.length-1];
if((lastMsg.ext.businessType == null || lastMsg.ext.businessType == 'patient_profile' || lastMsg.ext.businessType == 'profileFinish' || lastMsg.ext.businessType == 'facePicFinish'||lastMsg.ext.businessType == 'suifangFinish') && (lastMsg.type == 'txt' || lastMsg.types == 'txt')){
if(lastMsg.data == null || lastMsg.data == ''){
lastMsg.data = lastMsg.body.msg;
}
}else if(lastMsg.type == 'img' || lastMsg.types == 'img'){
lastMsg.data = '[图片]';
}else if(lastMsg.types == 'voice'){
lastMsg.data = '[语音]';
}else if(lastMsg.ext.businessType != null && (lastMsg.ext.businessType == 'EndOrder' || lastMsg.ext.businessType == 'doctorEndOrder')){
lastMsg.data = '本次服务已结束';
}
var newYear = new Date().getFullYear();
var newMonth= new Date().getMonth()+ 1;
var newDay = new Date().getDate();
var newDays = new Date().getDate()-7;
var newTime = newYear + '/' + newMonth + '/' + newDay + ' 00:00:00';
var newTimee = '';
var newTimes = new Date(newTime).getTime();
if(newDays == 0){
var oldMonth = newMonth - 1;
var oldDay = new Date(newYear, oldMonth, newDays).getDate();
newTimee = newYear + "/" + oldMonth + "/" + oldDay + " 00:00:00";
}else if(newDays < 0){
var oldMonth = newMonth - 1;
var oldDay = new Date(newYear, oldMonth, 0).getDate() + newDays;
newTimee = newYear + "/" + oldMonth + "/" + oldDay + " 00:00:00";
}else{
newTimee = newYear + "/" + oldMonth + "/" + newDays + " 00:00:00";
}
var newTimese = new Date(newTimee).getTime();
if(lastMsg.time > newTimes){
lastMsg.times = common.timestampToTime(lastMsg.time,5);
}else if(lastMsg.time < newTimes && lastMsg.time > newTimese){
lastMsg.times = common.timestampToTime(lastMsg.time,8);
}else{
lastMsg.times = common.timestampToTime(lastMsg.time,2);
}
res.doctorsItems[i].myMessages = lastMsg;
}
res.doctorsItems[i].buytime = new Date(res.doctorsItems[i].buytime).getTime();
res.doctorsItems[i].style = {'background-image': 'url('+res.doctorsItems[i].doctorFace+')'};
if(res.doctorsItems[i].myMessages == null || res.doctorsItems[i].myMessages == ''){
oldList.push(res.doctorsItems[i]);
}else{
newList.push(res.doctorsItems[i]);
}
}
oldList.sort(_this.sortTime);
newList.sort(_this.sortTime);
for(var j=0;j<oldList.length;j++){
_this.doctorList.push(oldList[j]);
}
for(var n=0;n<newList.length;n++){
_this.doctorList.unshift(newList[n]);
}
var doctorId = common.getQueryString(window.location.search.substr(1),"doctorId");
if (doctorId != null && doctorId != "") {

if (common.getLock(_this, "todoctorLock" + doctorId, null, false)) {

for (var i = 0; i < _this.doctorList.length; i++) {
if(_this.$store.state.AllOfValue.ImDoctorInfo!=undefined){
if (_this.doctorList[i].doctorId == doctorId&&_this.doctorList[i].inquiryPatientId==_this.$store.state.AllOfValue.ImDoctorInfo.inquiryPatientId) {
_this.$store.state.AllOfValue.ImDoctorInfo = _this.doctorList[i];
_this.$store.state.AllOfValue.doctorId = _this.doctorList[i].doctorId;
_this.$router.push({ path: "/im" });
this.$store.state.tabIndex= 'immsg';
}else if(_this.doctorList[i].doctorId == doctorId&&_this.doctorList[i].inquiryPatientId==_this.$store.state.buyuser) {
_this.$store.state.AllOfValue.ImDoctorInfo = _this.doctorList[i];
_this.$store.state.AllOfValue.doctorId = _this.doctorList[i].doctorId;
_this.$router.push({ path: "/im" });
this.$store.state.tabIndex= 'immsg';
}
}else{
if (_this.doctorList[i].doctorId == doctorId&&_this.doctorList[i].inquiryPatientId==_this.$store.state.buyuser) {
_this.$store.state.AllOfValue.ImDoctorInfo = _this.doctorList[i];
_this.$store.state.AllOfValue.doctorId = _this.doctorList[i].doctorId;
_this.$router.push({ path: "/im" });
this.$store.state.tabIndex= 'immsg';
}
}




}
}
}
if(_this.doctorList.length == 1){
var doctorId = _this.doctorList[0].doctorId;
if(common.getLock(_this,'todoctorLock' + doctorId, null, false)) {

_this.$store.state.AllOfValue.ImDoctorInfo = _this.doctorList[0];
_this.$store.state.AllOfValue.doctorId = _this.doctorList[0].doctorId;
_this.$router.push({ path: '/im'});
this.$store.state.tabIndex= 'immsg';
}
}
if(_this.doctorList.length == 0){
return;
_this.moreDoctor();

}
}
);
_this.getMyInquiry();














},
sortTime(a, b) {
if (a.myMessages != null) {
return a.myMessages.time - b.myMessages.time;
}
return b.buytime - a.buytime;
},
routerTo(doctorInfo) {
if (doctorInfo != "") {


this.$store.state.AllOfValue.ImDoctorInfo = doctorInfo;
this.$store.state.AllOfValue.doctorId = doctorInfo.doctorId;
this.$store.state.tabIndex= 'immsg';
this.$router.push({ path: "/im" });
var newtemp=JSON.parse(localStorage.getItem("temp"));
if(newtemp!=null){
newtemp.forEach(function(item1, index, arr) {
if(item1 == doctorInfo.inquiryPatientId) {
arr.splice(index, 1);
}
});
localStorage.removeItem("temp");
localStorage.setItem("temp",JSON.stringify(newtemp));
this.websocketPeople1=localStorage.getItem("temp")?localStorage.getItem("temp"):[]
}
}
},
moreDoctor(){
this.$store.state.doctorSearch='';
this.$router.push({ path: '/doctorList'})
},
moreDoctor1(){
this.$store.state.doctorSearch='';
this.$router.push({ path: '/doctorSearch'})
},

initWebSocket(){ //初始化weosocket
const wsuri = 'wss://service.51bjhzy.com/webSocket';
this.websocket = new WebSocket(wsuri);
this.websocket.onopen = this.websocketonopen;
this.websocket.onerror = this.websocketonerror;
this.websocket.onmessage = this.websocketonmessage;
this.websocket.onclose = this.websocketclose;
},

websocketonopen() {
console.log("WebSocket连接成功");


},
websocketonerror(e) { //错误
console.log("WebSocket连接发生错误");
},
websocketonmessage(e){ //数据接收
var oldpeople=JSON.parse(localStorage.getItem("temp"))!=null?JSON.parse(localStorage.getItem("temp")):[];
var jsObject = JSON.parse(e.data);
oldpeople.push(jsObject.toUserId);
this.websocketPeople=Array.from(new Set(oldpeople));
localStorage.removeItem("temp");
localStorage.setItem("temp", JSON.stringify(this.websocketPeople));
this.websocketPeople1=localStorage.getItem("temp")?localStorage.getItem("temp"):[];


},

websocketsend(agentData){//数据发送
this.websock.send(agentData);
},

websocketclose(e){ //关闭
console.log("WebSocket已关闭");

},









































},
destroyed: function() {

this.websocketclose();
},
updated() {
var _this = this;
}
};



// WEBPACK FOOTER //
// ./src/views/physicianVisits/index.vue